<template>
  <section>
    <notifications></notifications>
    <sidebar-help
      :title="$route.meta.title"
      :items="guides"
      :loader="loader"
      :toggleSidebar="visibleSideBar"
      @closeSidebar="closeSidebar"
    />

    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-4 col-md-6 col-sm-6 col-5 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>
          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div class="col-lg-8 col-md-6 col-sm-6 col-7 text-right">
          <div class="box-buttons">
            <base-button
              v-if="selectedRows.length > 0 && canUserDelete"
              type="outline-neutral"
              class="min-button btn-line-danger mr-2"
              @click="deleteManyDocuments(selectedRows)"
            >
              <i class="flaticon-delete icon-no-margin"></i>
              <strong class="d-lg-block d-none">Delete</strong>
            </base-button>

            <base-button
              type="primary"
              @click="$router.push('/tools/documentation/new')"
              class="min-button"
            >
              <i class="flaticon-plus"></i>New
              <strong class="d-lg-block d-none ml-1"> Document</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="main-buttons">
        <div class="row">
          <div
            class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 align-self-center mb-0"
          >
            <b-form-group class="mb-0">
              <b-input-group size="sm" class="input-search">
                <b-input-group-prepend class="pt-1 pl-1">
                  <i class="flaticon-bold-magnifier"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="filter-input"
                  v-model.trim="simpleSearch"
                  v-on:input="applySimpleSearch"
                  type="search"
                  placeholder="Search Anything..."
                  class="border-none"
                ></b-form-input>

                <b-input-group-append class="pt-1 pb-0">
                  <b-button
                    variant="neutro"
                    v-b-toggle.toggleFilters
                    class="p-0"
                  >
                    <i class="flaticon-equalizer"></i
                  ></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <div
            class="col-xl-8 col-lg-8 col-md-6 col-sm-12 col-12 alinmov2 align-self-center"
          >
            <div>
              <div class="box-buttons">
                <base-button
                  type="outline-neutral"
                  class="min-button"
                  v-if="query"
                  @click="resetSearchFilter()"
                >
                  <i class="flaticon-eraser"></i>Reset Search
                </base-button>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Type"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-tools-document"></i>
                    <strong>Type</strong>
                  </base-button>

                  <div
                    class="dropdown-item"
                    v-for="filter in typeDocument"
                    :key="filter.value"
                    :class="documentType === filter.value ? 'active' : ''"
                    @click="applyFilterByDocumentType(filter.value)"
                  >
                    {{ filter.label }}
                  </div>
                </base-dropdown>
                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral "
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-list-3"></i>
                    <strong>Apps</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    v-for="filter in apps"
                    :class="appType === filter.value ? 'active' : ''"
                    :key="filter.value"
                    @click="applyFilterByAppType(filter.value)"
                  >
                    {{ filter.name }}
                  </div>
                </base-dropdown>

                <base-dropdown
                  menu-on-right
                  class="nav-item"
                  tag="li"
                  title-tag="a"
                  title-classes="btn min-button btn-outline-neutral mt-md-0 mt-2"
                  title="Actions"
                >
                  <base-button slot="title" type="none" class="p-0 min-button">
                    <i class="flaticon-ammunition"></i>
                    <strong>Status</strong>
                  </base-button>
                  <div
                    class="dropdown-item"
                    v-for="filter in status"
                    :class="documentStatus === filter.value ? 'active' : ''"
                    :key="filter.value"
                    @click="applyFilterByDocumentStatus(filter.value)"
                  >
                    <i class="flaticon-rec" :class="filter.icon"></i>
                    {{ filter.label }}
                  </div>
                </base-dropdown>

                <base-button
                  type="outline-neutral"
                  class="min-button d-md-inline-block d-none"
                  v-b-toggle.toggleFilters
                >
                  <i class="flaticon-equalizer"></i>Advanced Search
                </base-button>
              </div>
            </div>
          </div>
          <div class="col-12">
            <b-collapse id="toggleFilters" class="mt-2">
              <div class="filters-advanced forms">
                <div class="card pb-2">
                  <div class="row">
                    <div
                      class="col-lg-6 col-md-6 col-sm-4 col-12 align-self-center"
                    >
                      <h4 class="subtitle mb-4">Filters</h4>
                    </div>
                    <div
                      class="col-lg-6 col-md-6 col-sm-8 col-12 text-right align-self-center pb-4"
                    >
                      <base-button
                        type="outline-neutral"
                        class="min-button"
                        v-b-toggle.toggleFilters
                      >
                        <i class="flaticon-cancel"></i>
                        Close
                      </base-button>
                      <base-button
                        type="outline-neutral"
                        class="min-button"
                        @click="resetSearchFilter()"
                      >
                        <i class="flaticon-eraser"></i> Clear
                      </base-button>
                      <base-button
                        type="primary"
                        class="min-button mb-2"
                        @click="applyAdvancedSearch"
                      >
                        <i class="flaticon-bold-check-3"></i> Apply
                      </base-button>
                    </div>
                  </div>
                  <div class="row formsearch">
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                      <WSelect
                        filterable
                        remote
                        reserve-keyword
                        placeholder="Enter a User"
                        v-model.trim="filters.type"
                        id="search_type"
                        name="search_type"
                        label="Type Document"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in typeDocument"
                          class="select-danger"
                          :value="item.value"
                          :key="index"
                          :label="`${item.label}`"
                        >
                        </el-option>
                      </WSelect>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                      <WSelect
                        filterable
                        remote
                        reserve-keyword
                        placeholder="Select an App"
                        v-model.trim="filters.app"
                        id="app_filter"
                        name="app_filter"
                        label="Apps"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in apps"
                          class="select-danger"
                          :value="item.value"
                          :label="`${item.name}`"
                          :key="index"
                        ></el-option>
                      </WSelect>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                      <WSelect
                        filterable
                        remote
                        reserve-keyword
                        placeholder="Select a Module"
                        v-model.trim="filters.module"
                        id="modules_search"
                        name="modules_search"
                        label="Module"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in modules"
                          class="select-danger"
                          :value="item.value"
                          :label="`${item.name}`"
                          :key="index"
                        ></el-option>
                      </WSelect>
                    </div>

                    <div class="col-xl-3 col-lg-3 col-md-4 col-sm-4 col-12">
                      <WSelect
                        filterable
                        remote
                        reserve-keyword
                        placeholder="Select a Status"
                        v-model.trim="filters.status"
                        id="status_search"
                        name="status_search"
                        label="Status"
                        clearable
                      >
                        <el-option
                          v-for="(item, index) in status"
                          class="select-danger"
                          :value="item.value"
                          :label="`${item.label}`"
                          :key="index"
                        ></el-option>
                      </WSelect>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>

            <div class="row">
              <div class="col-12 pt-0 pb-3 text-right" v-if="activeFilter">
                <span><strong>Filtered by: </strong></span>

                <ul class="box-tags-filters">
                  <li class="tags-filters" v-if="simpleSearch">
                    {{ simpleSearch }}
                  </li>
                  <li class="tags-filters" v-if="filters.type || documentType">
                    Type: {{ getTypeFormat(filters.type || documentType) }}
                  </li>
                  <li class="tags-filters" v-if="filters.app || appType">
                    App: {{ getAppFormat(filters.app || appType) }}
                  </li>
                  <li class="tags-filters" v-if="filters.module">
                    Module: {{ getModuleFormat(filters.module) }}
                  </li>

                  <li
                    class="tags-filters"
                    v-if="filters.status || documentStatus"
                  >
                    Status:
                    {{ getStatusFormat(filters.status || documentStatus) }}
                  </li>

                  <li class="d-inline-block">
                    <span @click="resetSearchFilter()" class="curp"
                      ><i class="flaticon-cancel ml-2"></i
                    ></span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="box-table">
        <div class="row">
          <div
            class="col-xl-5 col-lg-7 col-md-12 col-sm-12 col-12 align-self-center order-lg-1 order-md-2 order-sm-2 order-2"
          >
            <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
              <b-form-radio-group
                id="radio-group-2"
                v-model="filterStatus"
                :aria-describedby="ariaDescribedby"
                name="radio-sub-component"
                button-variant="type-tab"
                buttons
                @change="filteredTab"
                class="buttons-rows-2"
              >
                <b-form-radio value="all">All</b-form-radio>
                <b-form-radio value="revision"
                  >In Revision<badge type="danger" class="square">{{
                    inRevision
                  }}</badge></b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </div>

          <div
            class="col-xl-7 col-lg-5 col-md-12 col-sm-12 col-12 order-lg-2 order-md-1 order-sm-1 order-1 text-right"
          >
            <div
              class="col-xl-7 col-lg-12 col-md-6 ml-auto d-inline-block mb-xl-0 mb-1"
            >
              <b-form-group
                label="Sort"
                label-for="sort-by-select"
                label-cols-sm="2"
                label-align-sm="right"
                label-size="sm"
                v-slot="{ ariaDescribedby }"
                class="mb-0"
                size="sm"
              >
                <b-input-group>
                  <b-form-select
                    id="sort-by-select"
                    v-model="sortBy"
                    :options="sortOptions"
                    @change="applySortBy"
                    :aria-describedby="ariaDescribedby"
                    class="w-70"
                    size="sm"
                  >
                    <template #first>
                      <option value="">-- None --</option>
                    </template>
                  </b-form-select>

                  <b-form-select
                    v-model="sortDesc"
                    :disabled="!sortBy"
                    @change="applySortType"
                    :aria-describedby="ariaDescribedby"
                    class="w-30"
                    size="sm"
                  >
                    <option :value="'asc'">Asc</option>
                    <option :value="'desc'">Desc</option>
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </div>

            <div class="d-inline-block mr-2">
              <b-form-group v-slot="{ ariaDescribedbyview }" class="mb-0">
                <b-form-radio-group
                  id="btn-radios-view"
                  v-model="view"
                  :aria-describedby="ariaDescribedbyview"
                  name="radios-btn-default"
                  buttons
                  @change="changeViewCard"
                  class="mb-0"
                  button-variant="outline-neutral pc-3"
                >
                  <b-form-radio value="table"
                    ><i class="flaticon-two" title="View Table"></i
                  ></b-form-radio>
                  <b-form-radio value="card"
                    ><i class="flaticon-menu" title="View Card"></i
                  ></b-form-radio>
                </b-form-radio-group>
              </b-form-group>
            </div>

            <div class="d-inline-block">
              <el-tooltip content="Help" placement="bottom">
                <base-button
                  type="outline-neutral"
                  class="btn-icon-only mb-0"
                  @click="openSideBar"
                >
                  <i class="flaticon-question-1 f-16 mr-0"></i>
                </base-button>
              </el-tooltip>
            </div>
          </div>
        </div>

        <pagination-block
          :pageCount="documents.pages"
          v-model="currentPage"
          :total="documents.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
        <b-table
          hover
          :items="records"
          :fields="fields"
          sort-by.sync="title"
          sort-asc.sync="true"
          selectable
          @row-selected="onRowSelected"
          select-mode="multi"
          ref="selectableTable"
          sort-icon-left
          responsive
          show-empty
          empty-filtered-text="There are no records matching your request"
          empty-text="There are no records to show"
          :stacked="cardview"
        >
          <template #head()="{ label, field: { key } }">
            <span v-if="key === 'selected'">
              <span
                @click="clearSelected"
                v-if="selectedRows.length === records.length"
                class="check-table selected"
              ></span>

              <span @click="selectAllRows" v-else class="check-table"></span>
            </span>
            <span v-else>{{ label }}</span>
          </template>
          <template #cell(selected)="{ rowSelected }">
            <template v-if="rowSelected">
              <span aria-hidden="true" class="check-table selected"></span>
              <span class="sr-only">Selected</span>
            </template>
            <template v-else>
              <span aria-hidden="true" class="check-table"></span>
              <span class="sr-only">Not selected</span>
            </template>
          </template>

          <template #cell(title)="data">
            <router-link :to="`/tools/documentation/${data.item._id}`">
              <div class="content">
                <span class="username hide-data"> {{ data.item.title }}</span>
              </div>
            </router-link>
          </template>

          <template #cell(type)="data">
            <span class="hide-data capitalize">{{
              getTypeFormat(data.item.type)
            }}</span>
          </template>

          <template #cell(app)="data">
            <span class="hide-data capitalize">{{
              getAppFormat(data.item.app)
            }}</span>
          </template>
          <template #cell(module)="data">
            <span class="hide-data capitalize">
              {{ getModuleFormat(data.item.module) }}</span
            >
          </template>
          <template #cell(date)="data">
            <span class="hide-data capitalize">{{
              getDateFormat(data.item.date)
            }}</span>
          </template>
          <template #cell(status)="data">
            <div
              class="capitalize badge-status"
              v-bind:class="statusValue(data.item.status)"
            >
              {{ getStatusFormat(data.item.status) }}
            </div>
          </template>

          <template #cell(actions)="data">
            <el-tooltip content="Edit Document" placement="bottom">
              <router-link
                class="icon-action text-info"
                :to="`/tools/documentation/${data.item._id}`"
              >
                <i class="flaticon-pencil text-primary"></i>
              </router-link>
            </el-tooltip>

            <el-tooltip content="Duplicate Document" placement="bottom">
              <span
                class="icon-action text-info ml-2"
                @click="duplicateDocument(data.item._id)"
              >
                <i class="flaticon-copy"></i>
              </span>
            </el-tooltip>

            <el-tooltip content="Delete" placement="bottom">
              <span
                class="icon-action text-danger ml-2"
                @click="deleteDocument(data.item._id)"
              >
                <i class="flaticon-delete"></i>
              </span>
            </el-tooltip>

            <!-- <el-tooltip
              content="See in Help"
              placement="bottom"
              v-if="data.item.app === 'INTERNAL'"
            >
              <a
                :href="
                  `help/${getSlugByValue(data.item.module)}/${data.item.slug}`
                "
                target="_blank"
                class="icon-action text-info ml-2"
                ><i class="flaticon-view-1 text-primary"></i
              ></a>
            </el-tooltip> -->
          </template>
        </b-table>

        <pagination-block
          :pageCount="documents.pages"
          v-model="currentPage"
          :total="documents.count"
          :limit="limit"
          @changeLimit="changeLimit"
          @changePage="changePage"
          @nextPage="nextPaginations"
          @prevPage="previousPaginations"
          position="bottom"
        ></pagination-block>
      </div>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment-timezone";
import WSelect from "@/components/Select";
import Swal from "sweetalert2";

import { DocumentsAPI } from "../../../../../core/api";
import {
  goBack,
  isUserAuthorized
} from "../../../../../helpers/commons.helpers";
import { APPS, MODULES } from "../../../../../core/constants";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "Documentation",

  data() {
    return {
      selectedRows: [],
      currentPage: 1,
      fields: [
        {
          key: "selected",
          label: "",
          sortable: false,
          class: "text-center",
          thStyle: { minWidth: "40px" }
        },
        {
          key: "title",
          label: "Title",
          sortable: true,
          thStyle: { minWidth: "200px" },
          class: "text-left"
        },

        {
          key: "type",
          label: "Type",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },

        {
          key: "app",
          label: "App",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },

        {
          key: "module",
          label: "Module",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },

        {
          key: "date",
          label: "Date",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6r"
        },

        {
          key: "status",
          label: "status",
          sortable: true,
          thStyle: { minWidth: "100px" },
          class: "alinmov6"
        },
        {
          key: "actions",
          label: "Actions",
          sortable: false,
          class: "alinmov6",
          thStyle: { minWidth: "80px" }
        }
      ],
      cardview: false,
      limit: 0,
      query: "",
      sortBy: "",
      sortDesc: "asc",
      sortOptions: [
        { value: "title", text: "Title" },
        { value: "type", text: "Type" },
        { value: "app", text: "App" },
        { value: "module", text: "Module" },
        { value: "date", text: "Date" }
      ],
      timeoutId: null,
      view: "table",
      filterStatus: "all",
      activeFilter: false,
      simpleSearch: "",
      filters: {
        type: "",
        app: "",
        module: "",
        date: "",
        status: ""
      },
      typeDocument: [
        { label: "Guide", value: "GUIDE" },
        { label: "Release", value: "RELEASE" },
        { label: "Support", value: "SUPPORT" }
      ],
      status: [
        {
          label: "Draft",
          value: "DRAFT",
          icon: "status-draft"
        },
        {
          label: "In Revision",
          value: "REVISION",
          icon: "text-warning"
        },
        {
          label: "Approved",
          value: "APPROVED",
          icon: "text-new"
        },
        {
          label: "Published",
          value: "PUBLISHED",
          icon: "text-success"
        }
      ],
      totalRevision: 0,
      modules: MODULES,
      apps: APPS,
      documentType: "",
      appType: "",
      documentStatus: "",
      queryTemp: "",
      guides: [],
      loader: false,
      visibleSideBar: false
    };
  },
  async mounted() {
    var bread = [
      {
        text: "Dashboard",
        to: "/dashboard"
      },
      {
        text: "Tools",
        to: "/tools"
      },

      {
        text: "Documentation",
        active: true
      }
    ];
    this.setItemsBread(bread);
  },
  async created() {
    await this.getLimit();
    this.limit = this.paginationLimit;
    this.currentPage = this.documentSearchCriteria.currentPage;
    this.query = this.documentSearchCriteria.query;
    this.initializeFilterData(this.query);
    this.get(true, this.limit, this.currentPage, this.query);
  },
  methods: {
    deleteItemInQuery(query, keys = []) {
      let searchParams = new URLSearchParams(query);
      keys.forEach(key => {
        if (searchParams.has(key)) {
          searchParams.delete(key);
        }
      });
      return searchParams.toString();
    },
    addElementInQuery(query, key, value) {
      let searchParams = new URLSearchParams(query);
      if (searchParams.has(key)) {
        searchParams.set(key, value ? value.trim() : value);
      } else {
        searchParams.append(key, value ? value.trim() : value);
      }
      return searchParams.toString();
    },
    async get(loader, limit, page, query) {
      this.getDocuments({
        loader: loader,
        limit: limit,
        page: page,
        query: query
      });
      this.setDocumentSearchCriteria({
        currentPage: page,
        limit: limit,
        query: query,
        status: true
      });
    },
    async applySortBy(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortBy", value);
        this.query = this.addElementInQuery(
          this.query,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortBy",
          value
        );
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          this.sortDesc
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    async applySortType(value) {
      if (this.filterStatus === "all") {
        this.query = this.addElementInQuery(this.query, "sortType", value);
        await this.get(true, this.limit, this.currentPage, this.query);
      } else {
        this.queryTemp = this.addElementInQuery(
          this.queryTemp,
          "sortType",
          value
        );
        await this.get(true, this.limit, this.currentPage, this.queryTemp);
      }
    },
    previousPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    nextPaginations(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    changePage(page) {
      if (this.filterStatus === "all") {
        this.get(true, this.limit, page, this.query);
      } else {
        this.get(true, this.limit, page, this.queryTemp);
      }
    },
    changeLimit(limit) {
      if (this.limit !== limit) {
        this.limit = limit;
        this.currentPage = 1;
        if (this.filterStatus === "all") {
          this.get(true, this.limit, this.currentPage, this.query);
        } else {
          this.get(true, this.limit, this.currentPage, this.queryTemp);
        }
      }
    },
    changeViewCard(value) {
      this.cardview = !(value === "table");
    },
    goToPreviousPage() {
      goBack(this);
    },
    initializeFilterData(query) {
      let searchCriteria = new URLSearchParams(query);
      this.simpleSearch = searchCriteria.has("search")
        ? searchCriteria.get("search")
        : "";

      this.filters.type = searchCriteria.has("type")
        ? searchCriteria.get("type")
        : "";
      this.documentType = this.filters.type;

      this.filters.status = searchCriteria.has("status")
        ? searchCriteria.get("status")
        : "";
      this.documentStatus = this.filters.status;

      this.filters.app = searchCriteria.has("app")
        ? searchCriteria.get("app")
        : "";
      this.appType = this.filters.app;
    },
    isInDocumentationModule(modules = []) {
      if (!(modules.indexOf("documentation") > -1)) {
        this.setDocumentSearchCriteria({
          currentPage: 1,
          limit: 15,
          query: "",
          status: false
        });
      }
    },
    onRowSelected(selectedRows) {
      this.selectedRows = selectedRows;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    statusValue(status) {
      if (status === "DRAFT") {
        return "status-draft";
      } else if (status === "REVISION") {
        return "status-started";
      } else if (status === "APPROVED") {
        return "status-new";
      } else if (status === "PUBLISHED") {
        return "status-confirmed";
      }
    },
    async applySimpleSearch(value) {
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(async () => {
        this.activeFilter = true;
        if (value) {
          if (this.filterStatus === "all") {
            this.query = this.addElementInQuery(this.query, "search", value);
            await this.get(true, this.limit, this.currentPage, this.query);
          } else {
            let query = this.addElementInQuery(this.queryTemp, "search", value);
            await this.get(true, this.limit, this.currentPage, query);
          }
        } else {
          this.query = this.deleteItemInQuery(this.query, ["search"]);
          await this.get(true, this.limit, this.currentPage, this.query);
        }
      }, 500);
    },
    async resetSearchFilter() {
      this.filters.app = "";
      this.filters.module = "";
      this.filters.status = "";
      this.filters.type = "";
      this.filterStatus = "all";
      this.query = "";
      this.queryTemp = "";
      this.currentPage = 1;
      this.simpleSearch = "";
      this.activeFilter = false;
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    buildParams(data) {
      const params = new URLSearchParams();
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach(value => params.append(key, value.toString()));
        } else {
          params.append(key, value.toString());
        }
      });
      return params.toString();
    },
    deleteEmptyElements(query) {
      return query
        .toString()
        .split("&")
        .filter(element => {
          let [key, value] = element.split("=");
          return key && value ? true : false;
        })
        .join("&");
    },
    async applyAdvancedSearch() {
      this.filterStatus = "all";
      this.currentPage = 1;
      this.activeFilter = true;
      let searchParams = this.buildParams({
        ...Object.fromEntries(new URLSearchParams(this.query)),
        ...this.filters
      });
      this.query = this.deleteEmptyElements(searchParams.toString());
      await this.get(true, this.limit, this.currentPage, this.query);
    },
    filteredTab(filterStatus) {
      this.currentPage = 1;
      if (filterStatus == "all") {
        this.get(true, this.limit, this.currentPage, this.query);
      } else {
        if (this.inRevision > 0) {
          this.queryTemp = this.addElementInQuery(
            this.query,
            "status",
            "REVISION"
          );
          this.get(true, this.limit, 1, this.queryTemp);
        } else {
          this.documents.docs = [];
        }
      }
    },
    applyFilterByDocumentType(value) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.documentType = value;
      this.currentPage = 1;
      this.query = this.addElementInQuery(this.query, "type", value);
      this.get(true, this.limit, this.currentPage, this.query);
    },
    applyFilterByAppType(value) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.appType = value;
      this.currentPage = 1;
      this.query = this.addElementInQuery(this.query, "app", value);
      this.get(true, this.limit, this.currentPage, this.query);
    },
    applyFilterByDocumentStatus(value) {
      this.filterStatus = "all";
      this.activeFilter = true;
      this.documentStatus = value;
      this.currentPage = 1;
      this.query = this.addElementInQuery(this.query, "status", value);
      this.get(true, this.limit, this.currentPage, this.query);
    },
    async duplicateDocument(documentId) {
      let { value } = await Swal.fire({
        title: "Duplicate Document",
        html:
          "Are you sure you want to <strong>duplicate</strong> this Document?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.$router.push(`/tools/documentation/new?duplicate=${documentId}`);
      }
    },
    getStatusFormat(status) {
      if (status === "DRAFT") {
        return "Draft";
      } else if (status === "REVISION") {
        return "In Revision";
      } else if (status === "APPROVED") {
        return "Approved";
      } else if (status === "PUBLISHED") {
        return "Published";
      } else {
        return "Unknown";
      }
    },
    getDateFormat(date) {
      return moment
        .parseZone(date)
        .utc(true)
        .format("DD-MMM-YYYY");
    },
    getTypeFormat(type) {
      if (type === "GUIDE") {
        return "Guide";
      } else if (type === "RELEASE") {
        return "Release";
      } else if (type === "SUPPORT") {
        return "Support";
      }
    },
    getAppFormat(value) {
      let app = this.apps.find(app => app.value === value);
      if (app) {
        return app.name;
      } else {
        return "-";
      }
    },
    getModuleFormat(value) {
      let module = this.modules.find(module => module.value === value);
      if (module) {
        return module.name;
      } else {
        return "-";
      }
    },
    async deleteDocument(documentId) {
      let { value } = await Swal.fire({
        title: "Delete Document",
        text: "Are you sure do you want to delete this Document?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteDocumentById(documentId);
      }
    },
    async deleteDocumentById(documentId) {
      try {
        this.setLoad(true);
        let { data } = await DocumentsAPI.deleteDocumentById(
          documentId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Document has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    async deleteManyDocuments(documents = []) {
      let { value } = await Swal.fire({
        title: "Delete Documents",
        text: "Are you sure do you want to delete the selected Documents?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        await this.deleteManyDocumentsById(
          documents.map(document => document._id)
        );
      }
    },
    async deleteManyDocumentsById(documents = []) {
      try {
        this.setLoad(true);
        let { data } = await DocumentsAPI.deleteManyDocumentsById(
          documents,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.data.deleted) {
          this.get(true, this.limit, this.currentPage, this.query);
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Documents has been Deleted",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation couldn't be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation couldn't be completed. Please try again"
        );
      }
    },
    closeSidebar(status) {
      this.visibleSideBar = status;
    },
    async openSideBar() {
      this.visibleSideBar = true;
      this.loader = true;
      this.guides = await this.getSupportDocuments("INTERNAL", "DOCUMENTATION");
      this.loader = false;
    },
    async getSupportDocuments(app, module) {
      try {
        let { data } = await DocumentsAPI.getSupportDocuments(
          app,
          module,
          this.sesion.token
        );
        if (data.status) {
          return data.data;
        } else {
          return [];
        }
      } catch (error) {
        return [];
      }
    },
    getSlugByValue(value) {
      if (value === "ACCOUNT") {
        return "account";
      } else if (value === "DRIVER") {
        return "driver";
      } else if (value === "AREAS") {
        return "areas";
      } else if (value === "CUSTOMERS") {
        return "customers";
      } else if (value === "DESTINATIONS") {
        return "destinations";
      } else if (value === "DOCUMENTATION") {
        return "documentation";
      } else if (value === "PARTNERS") {
        return "partners";
      } else if (value === "EXPERIENCES") {
        return "experiences";
      } else if (value === "GLOBAL") {
        return "global";
      } else if (value === "LOGS") {
        return "logs";
      } else if (value === "PROFILE") {
        return "profile";
      } else if (value === "RATES") {
        return "rates";
      } else if (value === "RESERVATIONS") {
        return "reservations";
      } else if (value === "SUPPLIERS") {
        return "suppliers";
      } else if (value === "TEAM") {
        return "team";
      } else if (value === "VEHICLES") {
        return "vehicles";
      } else if (value === "VEHICLES_GALLERY") {
        return "vehicles-gallery";
      } else if (value === "DASHBOARD") {
        return "dashboard";
      } else if (value === "RELEASE") {
        return "release";
      } else if (value === "GUIDE") {
        return "guide";
      } else if (value === "SUPPORT") {
        return "support";
      } else if (value === "") {
        return "release";
      }
    },
    ...mapMutations(["setLoad", "setItemsBread", "setDocumentSearchCriteria"]),
    ...mapActions(["getDocuments", "getLimit"])
  },
  computed: {
    records: function() {
      return this.documents.docs ? this.documents.docs : [];
    },
    inRevision: function() {
      if (this.documents.metadata) {
        return this.documents.metadata.inRevision;
      } else {
        return 0;
      }
    },
    ...mapGetters([
      "sesion",
      "userRole",
      "sigout",
      "paginationLimit",
      "documents",
      "documentSearchCriteria"
    ]),
    canUserDelete() {
      return isUserAuthorized("TOOLS", this.userRole, "DELETE");
    },
    canUserExport() {
      return isUserAuthorized("TOOLS", this.userRole, "EXPORT");
    }
  },
  destroyed() {
    clearTimeout(this.timeoutId);
  },
  beforeRouteLeave(to, from, next) {
    this.isInDocumentationModule(to.meta.modules);
    next();
  },
  components: {
    WSelect: WSelect,
    flatPickr,
    Swal
  }
};
</script>
